import React from "react";
import styles from './CircleProgress.module.less';
export function CircleProgress({ children, percent }) {
    return (React.createElement("div", { className: styles.root },
        React.createElement("svg", { viewBox: "0 0 50 50" },
            React.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "1" }),
            React.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "2", style: { strokeDashoffset: `-${Math.round(126 / 100 * percent)}` } })),
        React.createElement("div", { className: styles.content }, children)));
}
